function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.776 6.597a.831.831 0 011.171-.097c.464.394.9.795 1.307 1.2a.831.831 0 11-1.172 1.18c-.377-.375-.78-.747-1.21-1.111a.831.831 0 01-.096-1.172z",
  fill: "#2D2D2D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.663 24C2.663 12.216 12.216 2.663 24 2.663c3.888 0 7.53 1.039 10.668 2.854a.831.831 0 00.833-1.44A22.891 22.891 0 0024 1C11.297 1 1 11.297 1 24v.137c.03 4.926 1.892 10.069 4.293 13.262.132.176.323.306.544.31.214.006.485-.03.663-.209.375-.375.303-.75.244-.914a.684.684 0 00-.094-.163A21.24 21.24 0 012.663 24zM45.337 24c0 11.784-9.553 21.337-21.337 21.337a21.26 21.26 0 01-8.866-1.923.622.622 0 00-.282-.067c-.222.01-.637.092-.844.553-.225.5.19.884.392 1.032a.999.999 0 00.211.115C17.36 46.198 20.85 47 24 47c12.703 0 23-10.297 23-23 0-2.503-.66-5.235-1.494-7.598-.835-2.363-1.871-4.434-2.68-5.618a.831.831 0 00-1.373.938c.705 1.032 1.683 2.963 2.485 5.233.801 2.27 1.4 4.803 1.4 7.045z",
  fill: "#2D2D2D"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.923 41.623a.831.831 0 01-1.166.145c-.48-.374-.932-.757-1.356-1.145a.831.831 0 111.123-1.226c.392.359.81.713 1.255 1.06a.831.831 0 01.144 1.166z",
  fill: "#2D2D2D"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.425 35.265l-.003-14.725a.1.1 0 00-.014-.014.296.296 0 00-.183-.053H21.79c-.436 0-.789-.33-.789-.737 0-.406.353-.736.789-.736h4.436c.866 0 1.775.586 1.775 1.53v14.735c0 .406-.353.735-.788.735-.434 0-.787-.329-.787-.735z",
  fill: "#2D2D2D"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.25 37.118c.414 0 .75.337.75.752v.568a.751.751 0 11-1.5 0v-.568c0-.415.336-.752.75-.752z",
  fill: "#2D2D2D"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 38.426l-.003-17.675a.75.75 0 10-1.497 0v17.687c0 .964.864 1.562 1.688 1.562H23.5a.751.751 0 000-1.504h-2.813a.267.267 0 01-.173-.055.096.096 0 01-.014-.015z",
  fill: "#2D2D2D"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.5 9.5a3 3 0 103 3 .75.75 0 011.5 0 4.5 4.5 0 11-2.812-4.173.75.75 0 01-.563 1.39A2.989 2.989 0 0023.5 9.5z",
  fill: "#2D2D2D"
});
function SvgGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
export default __webpack_public_path__ + "/img/general.svg";
export { SvgGeneral as ReactComponent };